<template>
  <slider-bonuses />

  <the-nav />

  <div class="main-wrap">
    <div class="bonus-wrap">
      <div class="bonus-page-title">Приветственный пакет бонусов</div>
      <div class="bonus-fl">
        <div class="bonus-item">
          <div class="bonus-item-image"><img src="/images/bonus-item1.webp" alt="" class="bonus-item1" /></div>
          <div class="bonus-item-content">
            <div class="bonus-item-title1">Бонус за первый депозит</div>
            <div class="bonus-item-title2">Бонус 100%</div>
            <div class="bonus-item-title3">ДО 20 000 РУБЛЕЙ</div>
            <div class="bonus-item-title4">Вейджер х 40</div>
          </div>
        </div>
        <div class="bonus-item bia">
          <div class="bonus-item-image"><img src="/images/bonus-item2.webp" alt="" class="bonus-item2" /></div>
          <div class="bonus-item-content">
            <div class="bonus-item-title1">Бонус за второй депозит</div>
            <div class="bonus-item-title5">Бонус 150%</div>
            <div class="bonus-item-title6">ДО 10 000 РУБЛЕЙ</div>
            <div class="bonus-item-title4">Вейджер х 30</div>
          </div>
        </div>
        <div class="bonus-item-line">
          <div class="bonus-item-line-title">
            <div class="bonus-item-t1">+30 фриспинов</div>
            <div class="bonus-item-t2">Дополнительный бонус</div>
          </div>
        </div>
      </div>

      <div class="dtext-block">
        <div class="dtext-title-y">Бонус 100% на Ваш первый депозит</div>
        <p>
          Вы впервые в игровом клубе Миллион? Тогда специально для Вас мы увеличим Ваш первый депозит в два раза.
          Совершите депозит от 1000 ₽ до 20 000 ₽ и активируйте бонус в кассе &mdash; Вы получите 100% бонус на Ваш
          депозит. Ограничений по выигрышу нет. Вейджер х40.
        </p>
        <p>
          Пример: Вы пополнили на 1000 ₽, а играете на 2000 ₽ &mdash; шансы выиграть удвоились. Для отыгрыша Вам
          потребуется совершить ставок на 80 000 ₽.
        </p>
        <p>
          ❗ Важно. Бонус на депозит может быть получен только до момента первой ставки после успешного пополнения
          счета.
        </p>
        <p></p>
        <div class="dtext-title-y">Бонус 150% на Ваш второй депозит</div>
        <p>
          Внесите Ваш второй депозит от 1000 ₽ в игровом клубе Миллион и получите 150% бонус. При внесении второго
          депозита, Вы имеете право получить максимальный бонус до 10 000 ₽. Ограничений по выигрышу нет. Вейджер х30.
        </p>
        <p>
          ❗ Важно. Бонус на депозит может быть получен только до момента первой ставки после успешного пополнения
          счета.
        </p>
        <p></p>
        <div class="dtext-title-y">30 фриспинов в Book of Ra</div>
        <p>
          Для того чтобы активировать 30 фриспинов в Book of Ra, Вам нужно совершить депозит от 500 ₽, перейти в
          <b>Кассу &rAarr; Бонусы</b> и нажать &laquo;Активировать&raquo; на соответствующем бонусе. Ограничение по
          выигрышу 1000 ₽. Вейджер 40x.
        </p>
        <p></p>

        <ul class="dtext-ul">
          <li>Войдите в кассу и совершите депозит удобным для вас способом, на требуемую сумму.</li>
          <li>
            Перейдите во вкладку «Бонусы» в кассе и активируйте соответсвующий бонус нажав кнопку
            &laquo;Активировать&raquo;.
          </li>
          <li>
            Подтвердите Ваш номер телефона с помощью ввода 4 цифр из СМС, которые нужно ввести в поле для активации
            номера.
          </li>
          <li>Готово! На ваш счет зачислен бонус в зависимости от суммы вашего депозита.</li>
        </ul>
        <div class="dtext-title-g">Удачной игры!</div>
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import PlayLine from '@/components/PlayLine'
import TheFooter from '@/components/TheFooter'
import TheHeader from '@/components/TheHeader'
import TheNav from '@/components/TheNav'
import BonusesLine from '@/components/BonusesLine.vue'
import SliderBonuses from '@/components/sliders/SliderBonuses'

export default {
  name: 'Bonuses',
  components: { SliderBonuses, BonusesLine, TheNav, TheHeader, TheFooter, PlayLine },
}
</script>

<style scoped></style>
